/**
 * One entry of a sent form: its label's text and what was typed.
 * @typedef entry
 * @type {object}
 * @property {string} name
 * @property {string} value
 */

const form = {
  /**
   * Posts a visitor's form to the server with the proof their browser
   * solved, answering whether it was kept
   * @param {entry[]} entries - the form's fields in page order
   * @param {string} proof - the solved challenge, empty when there is none
   * @returns {Promise<boolean>}
   */
  send: (entries, proof) =>
    fetch(`/_stenzil/form`, {
      method: `POST`,
      headers: { "Content-Type": "application/json", "X-Form-Proof": proof },
      body: JSON.stringify(entries),
    })
      .then((resp) => resp.status === 200)
      .catch((err) => {
        console.debug(err);
        return false;
      }),
};
export default form;
